import React from 'react';
import { Icon } from '@digitools/honest-ui';
import Facebook from '@mui/icons-material/Facebook';
import X from '@mui/icons-material/X';
import YouTube from '@mui/icons-material/YouTube';
import LinkedIn from '@mui/icons-material/LinkedIn';
import Instagram from '@mui/icons-material/Instagram';
// Same 5 links/URLs honest-react's IconLinks bakes in behind showSocialIcons.
// Brand marks aren't in the honest-ui icon set — routed through the MUI adapter.
export const footerSocialLinks = [
    { label: "Lincoln Financial's Facebook Page", url: 'https://www.facebook.com/lincolnfinancial/', externalLink: true, icon: <Icon component={Facebook} color='white'/> },
    { label: "Lincoln Financial's X Page", url: 'https://x.com/LincolnFncl', externalLink: true, icon: <Icon component={X} color='white'/> },
    { label: "Lincoln Financial's YouTube Page", url: 'https://www.youtube.com/@Lincoln_Financial', externalLink: true, icon: <Icon component={YouTube} color='white'/> },
    { label: "Lincoln Financial's LinkedIn Page", url: 'https://www.linkedin.com/company/lincolnfinancial/', externalLink: true, icon: <Icon component={LinkedIn} color='white'/> },
    { label: "Lincoln Financial's Instagram Page", url: 'https://www.instagram.com/lincolnfinancial', externalLink: true, icon: <Icon component={Instagram} color='white'/> },
];
